import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import IndexVersion from './views/nav1/IndexVersion.vue'
import IndexBanner from './views/nav1/IndexBanner.vue'
import AddBanner from './views/nav1/AddBanner.vue'
import IndexTopic from './views/nav1/IndexTopic.vue'
import AddTopic from './views/nav1/AddTopic.vue'
import Form from './views/nav1/Form.vue'
import user from './views/nav1/user.vue'
import ShopList from './views/nav1/ShopList.vue'
import AddShop from './views/nav1/AddShop.vue'
import IndexCatogrey from './views/nav1/IndexCatogrey.vue'
import AddCategory from './views/nav1/AddCategory.vue'
import EditBanner from './views/nav1/EditBanner.vue'
import ProductClassify from './views/product/ProductClassify.vue'
import ProductTag from './views/product/ProductTag.vue'
import ProductList from './views/product/ProductList.vue'
import EditTopic from './views/nav1/EditTopic.vue'
import AddProduct from './views/product/AddProduct.vue'
import Equipment from './views/product/Equipment.vue'
import AddEquipment from './views/product/AddEquipment.vue'
import AddEquipmentX from './views/product/AddEquipmentX.vue'
import EditEquipmentX from './views/product/EditEquipmentX.vue'
import OptionalList from './views/product/OptionalList.vue'
import AddOptional from './views/product/AddOptional.vue'
import EditOptional from './views/product/EditOptional.vue'
import EditEquipment from './views/product/EditEquipment.vue'
import UserList from './views/user/UserList.vue'
import UserView from './views/user/UserView.vue'
import Identified from './views/user/Identified.vue'
import ChangeIdentified from './views/user/ChangeIdentified.vue'
import OrderList from './views/order/OrderList.vue'
import EditProduct from './views/product/EditProduct.vue'
import EditShop from './views/nav1/EditShop.vue'
import StorageList from './views/order/StorageList.vue'
import CommentList from './views/order/CommentList.vue'
import OrderDetail from './views/order/OrderDetail.vue'
import FeedBack from './views/order/FeedBack.vue'
import OrderExpress from './views/order/OrderExpress.vue'
import SendExpress from './views/order/SendExpress.vue'
import BackDevice from './views/order/BackDevice.vue'
import BackExpress from './views/order/BackExpress.vue'
import DeviceBack from './views/order/DeviceBack.vue'
import WechatPic from './views/other/WechatPic.vue'
import Banner from './views/other/Banner.vue'
import Rules from './views/other/Rules.vue'
import RentRule from './views/other/RentRule.vue'
import Help from './views/other/Help.vue'
import HotSearch from './views/other/HotSearch.vue'
import About from './views/other/About.vue'
import ZmSetting from './views/other/ZmSetting.vue'
import AccountList from './views/account/AccountList.vue'
import GetStatistics from './views/other/GetStatistics.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: '首页设置',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: '/main', component: IndexVersion, name: '首页版本设置' },
            { path: '/banner', component: IndexBanner, name: '', hidden: true},
            { path: '/addBanner', component: AddBanner, name: '', hidden: true},
            { path: '/indexTopic', component: IndexTopic, name: '',hidden: true},
            { path: '/addtopic', component: AddTopic, name: '',hidden: true},
            { path: '/shopList', component: ShopList, name: '',hidden: true},
            { path: '/addShop', component: AddShop, name: '',hidden: true},
            { path: '/indexCatogrey', component: IndexCatogrey, name: '',hidden: true},
            { path: '/addCategory', component: AddCategory, name: '',hidden: true},
            { path: '/editBanner/:id', component: EditBanner, name: '',hidden: true},
            { path: '/editTopic/:id', component: EditTopic, name: '',hidden: true},
            { path: '/editProduct/:id', component: EditProduct, name: '',hidden: true},
            { path: '/addProduct', component: AddProduct, name: '',hidden: true},
            { path: '/editShop/:id', component: EditShop, name: '',hidden: true},

        ]
    },
    {
        path: '/product',
        component: Home,
        name: '商品管理',
        iconCls: 'el-icon-message',
        children: [
            { path: '/classify', component: ProductClassify, name: '商品分类' },
            { path: '/tag', component: ProductTag, name: '商品标签' },
            { path: '/list', component: ProductList, name: '商品列表' },
            { path: '/equipment/:id', component: Equipment, name: '设备列表', hidden: true},
            { path: '/addEquipment/:id', component: AddEquipment, name: '添加设备(设备入库)', hidden: true},
            { path: '/optinalList', component: OptionalList, name: '选配列表'},
            { path: '/addOptional', component: AddOptional, name: '',hidden: true},
            { path: '/editOptional/:id', component: EditOptional, name: '',hidden: true},
            { path: '/editEquipment/:id', component: EditEquipment, name: '',hidden: true},
            { path: '/addEquipmentX/:id', component: AddEquipmentX, name: '',hidden: true},
            { path: '/editEquipmentX/:id', component: EditEquipmentX, name: '',hidden: true},
            { path: '/changeIdentified/:id', component: ChangeIdentified, name: '', hidden: true}
        ]
    },
    {
        path: '/user',
        component: Home,
        name: '用户管理',
        iconCls: 'el-icon-message',
        children: [
            { path: '/userList', component: UserList, name: '用户列表'},
            { path: '/userView/:id', component: UserView, name: '', hidden: true},
            { path: '/identified', component: Identified, name: '实名认证管理'}
        ]
    },
    {
        path: '/order',
        component: Home,
        name: '订单管理',
        iconCls: 'el-icon-message',
        children: [
            { path: '/orderList', component: OrderList, name: '订单列表'},
            { path: '/storageList', component: StorageList, name: '仓库地址设置'},
            { path: '/commentList', component: CommentList, name: '评论列表'},
            { path: '/feedBack', component: FeedBack, name: '意见反馈列表'},
            { path: '/orderExpress', component: OrderExpress, name: '订单发货管理'},
            { path: '/backExpress', component: BackExpress, name: '退款订单列表'},
            { path: '/deviceBack', component: DeviceBack, name: '设备返还入库'},
            { path: '/orderDetail/:id', component: OrderDetail, name: '', hidden: true},
            { path: '/sendExpress/:id', component: SendExpress, name: '', hidden: true},
            { path: '/backDevice/:id', component: BackDevice, name: '', hidden: true}
        ]
    },
    {
        path: '/other',
        component: Home,
        name: '其他设置',
        iconCls: 'el-icon-message',
        children: [
            { path: '/wechatPic', component: WechatPic, name: '小程序分享封面图设置'},
            { path: '/indexBanner', component: Banner, name: 'banner设置'},
            { path: '/rules', component: Rules, name: '用户协议设置'},
            { path: '/rentRule', component: RentRule, name: '租赁规则'},
            { path: '/help', component: Help, name: '帮助中心'},
            { path: '/alipayRentRule', component: RentRule, name: '支付宝小程序租赁规则'},
            { path: '/alipayHelp', component: Help, name: '支付宝小程序帮助中心'},
            { path: '/hotWord', component: HotSearch, name: '热门标签设置'},
            { path: '/about', component: About, name: '关于我们'},
            { path: '/zmSetting', component: ZmSetting, name: '芝麻设置'}
        ]
    },
    {
        path: '/tong',
        component: Home,
        name: '数据统计',
        iconCls: 'el-icon-message',
        children: [
            {path: '/static', component: GetStatistics, name: '数据统计'}
        ]
    },
    {
        path: '/account',
        component: Home,
        name: '账号管理',
        iconCls: 'el-icon-message',
        children: [
            { path: '/accountList', component: AccountList, name: '账号列表'},
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js